import { render, staticRenderFns } from "./agendamento.vue?vue&type=template&id=6bea7a3b&"
import script from "./agendamento.vue?vue&type=script&lang=js&"
export * from "./agendamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports